var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlmacenes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "almacenes",
    transform: "translate(-1474 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2035",
    "data-name": "Rect\\xE1ngulo 2035",
    width: 26,
    height: 26,
    transform: "translate(1474 87)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "store-svgrepo-com",
    transform: "translate(1475.155 87.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27518",
    "data-name": "Trazado 27518",
    d: "M79.232,309.18H78.013a.849.849,0,0,0-.874.82.272.272,0,0,1-.291.237h-.5a.272.272,0,0,1-.291-.237.849.849,0,0,0-.874-.82H73.965a.875.875,0,0,0-.874.874v4.532a.875.875,0,0,0,.874.874h5.267a.875.875,0,0,0,.874-.874v-4.532A.875.875,0,0,0,79.232,309.18ZM77.087,312.8v1.436H76.11V312.8h-.533l1.022-1.152L77.62,312.8Z",
    transform: "translate(-69.164 -291.167)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27519",
    "data-name": "Trazado 27519",
    d: "M230.63,309.18h-1.219a.849.849,0,0,0-.874.82.272.272,0,0,1-.291.237h-.5a.272.272,0,0,1-.291-.237.849.849,0,0,0-.874-.82h-1.219a.875.875,0,0,0-.874.874v4.532a.875.875,0,0,0,.874.874h5.267a.875.875,0,0,0,.874-.874v-4.532A.875.875,0,0,0,230.63,309.18Zm-2.145,3.624v1.436h-.977V312.8h-.533L228,311.652l1.022,1.152Z",
    transform: "translate(-211.741 -291.167)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27520",
    "data-name": "Trazado 27520",
    d: "M154.931,185.219a.875.875,0,0,0,.874-.874v-4.532a.875.875,0,0,0-.874-.874h-1.219a.849.849,0,0,0-.874.82.272.272,0,0,1-.291.237h-.5a.272.272,0,0,1-.291-.237.849.849,0,0,0-.874-.82h-1.219a.875.875,0,0,0-.874.874v4.532a.875.875,0,0,0,.874.874Zm-2.633-3.808,1.022,1.152h-.533V184h-.977v-1.436h-.533Z",
    transform: "translate(-140.453 -168.514)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27521",
    "data-name": "Trazado 27521",
    d: "M28.294,5.93,18.632.279a2.293,2.293,0,0,0-2.19,0L6.779,5.93A2.326,2.326,0,0,0,5.692,7.824V23.479a.874.874,0,0,0,1.748,0V9.072H27.633V23.479a.874.874,0,1,0,1.748,0V7.824A2.326,2.326,0,0,0,28.294,5.93Z",
    transform: "translate(-5.692 0)",
    fill: "#777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmacenes);
export default __webpack_public_path__ + "static/media/almacenes.355eb10c152e260a388193ec6bbf3da7.svg";
export { ForwardRef as ReactComponent };